// Mock data for OneWay website

export const features = [
  {
    id: 1,
    icon: "Bookmark",
    title: "Capture jobs from any website",
    description: "Save job listings from LinkedIn, Indeed, Glassdoor, or any job board with one click."
  },
  {
    id: 2,
    icon: "LayoutDashboard",
    title: "Track every application in one dashboard",
    description: "See all your applications, their status, and next steps in a beautiful, organized view."
  },
  {
    id: 3,
    icon: "Sparkles",
    title: "Tailor resumes & cover letters with AI",
    description: "Generate customized application materials that match each job description perfectly."
  },
  {
    id: 4,
    icon: "Zap",
    title: "Autofill ATS forms in seconds",
    description: "Stop typing the same information over and over. Let OneWay fill it for you."
  },
  {
    id: 5,
    icon: "Mail",
    title: "Auto-track application status from email",
    description: "We read your confirmation emails and update your application status automatically."
  },
  {
    id: 6,
    icon: "Ban",
    title: "Avoid duplicate applications",
    description: "Never accidentally apply to the same job twice. We keep track for you."
  }
];

export const problems = [
  { id: 1, text: "20+ job boards to check daily" },
  { id: 2, text: "Endless application forms" },
  { id: 3, text: "Messy spreadsheets and notes" },
  { id: 4, text: "Missed follow-ups and deadlines" }
];

export const benefits = [
  { id: 1, text: "Save hours every week" },
  { id: 2, text: "Apply smarter, not harder" },
  { id: 3, text: "Stay organized under pressure" },
  { id: 4, text: "Never wonder 'Where did I apply?' again" }
];

export const demoVideos = [
  {
    id: 1,
    title: "OneWay Email Tracking Functionality",
    description: "Emails with Gmail read permission can read only job related emails for the past 30 days. If a matching email is found (regarding job applied, rejected, interviewed, or offer) in the inbox, it updates the job card status in OneWay Dashboard.",
    youtubeUrl: "https://www.youtube.com/watch?v=OfxpgUpk6vk",
    thumbnail: ""
  }
];

export const contactInfo = {
  phone: "+91 9440194688",
  email: "madala.vamsikrishna9@gmail.com",
  address: "India"
};
